<template>
	<div class="flex w-full bg-img" :class="{'h-screen': size === 'large'}">
		<div class="vx-col flex items-center justify-center flex-col mx-auto text-center">
			<img
				:class="{
					'img-size': size === 'large',
					'img-small': size === 'small',
				}"
				v-if="image"
				src="@/assets/images/pages/not-authorized.png"
				alt="graphic-not-authorized"
				class="mx-auto mb-4"
			/>
			<h1 class="sm:mx-0 mx-4 sm:mb-5 mb-1 d-theme-heading-color text-2xl" :class="titleColor">
				{{ title }}
			</h1>
			<p class="sm:mx-0 mx-4 sm:mb-12 mb-8">
				{{ message }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		size: {
			type: String,
			default: "small",
		},
		title: {
			type: String,
			default: "",
		},
		message: {
			type: String,
			default: "",
		},
		color: {
			type: String,
			default: "success",
		},
		image: {
			type: String,
		},
	},
	computed: {
		titleColor() {
			if (this.color === "primary") return "text-primary";
			else if (this.color === "success") return "text-success";
			else if (this.color === "warning") return "text-warning";
			else if (this.color === "danger") return "text-danger";
			else return "text-secondary";
		},
	},
};
</script>
<style lang="scss" scoped>
.img-size {
	margin-top: -100px;
}
.img-small {
	width: 150px;
	height: auto;
}
</style>
